export const QuoteStatus = {
	WAITING: 'Waiting',
	PRICED: 'Priced',
	USED: 'Used',
	REJECTED_BY_RECEIVER: 'RejectedTrader',
	REJECTED_BY_SENDER: 'RejectedAdvisor'
}

export const QuoteMode = {
	NONE: 0,
	SET_PRICE: 1,
	REJECT: 2,
	USE: 3
}

export const QuoteAction = {
	REQUEST: 1,
	SET_PRICE: 2,
	REJECT: 3,
	USE: 4,
	READ: 5
}

export const getFieldVisibility = (quote) => {
	return {
		labelPrice: [
			QuoteStatus.PRICED, 
			QuoteStatus.USED, 
			QuoteStatus.REJECTED_BY_SENDER
		].includes(quote.status),

		reason: [
			QuoteStatus.REJECTED_BY_SENDER,
			QuoteStatus.REJECTED_BY_RECEIVER
		].includes(quote.status)
	}
}